import { Resource } from './resource';
import { StateFilterVariables, FilterArgs } from './queryVariables/filters';
import { IdArgs, IdVariables } from './queryVariables/id';
/**
 * Abstrakcyjny resource do obsługi encji
 *
 * @export
 * @abstract
 * @class EntityResource
 * @extends {Resource}
 * @template EntityType
 */
export class EntityResource extends Resource {
    constructor({ entityName, listName = entityName + 's', addMutationName = entityName + 'Add', updateMutationName = entityName + 'Update', deleteMutationName = entityName + 'Delete' }) {
        super();
        /**
         * Zmienne zapytania o encję
         *
         * @protected
         * @memberof EntityResource
         */
        this.getVariables = IdVariables;
        /**
         * Argumenty zapytania o encję
         *
         * @protected
         * @memberof EntityResource
         */
        this.getArgs = IdArgs;
        /**
         * Zmienne zapytania o listę
         *
         * @protected
         * @memberof EntityResource
         */
        this.listVariables = StateFilterVariables;
        /**
         * Argumenty zapytania o listę
         *
         * @protected
         * @memberof EntityResource
         */
        this.listArgs = FilterArgs;
        /**
         * Zmienne mutacji usunięcia encji
         *
         * @protected
         * @memberof EntityResource
         */
        this.deleteVariables = IdVariables;
        /**
         * Argumenty mutacji usunięcia encji
         *
         * @protected
         * @memberof EntityResource
         */
        this.deleteArgs = IdArgs;
        this.entityQueryName = entityName;
        this.listQueryName = listName;
        this.addMutationName = addMutationName;
        this.updateMutationName = updateMutationName;
        this.deleteMutationName = deleteMutationName;
    }
    /**
     * Pobranie listy encji
     *
     * @param {Filter} filters
     * @param {boolean} [preventLoader=false]
     * @returns {Promise<ListResponse<EntityType>>}
     * @memberof EntityResource
     */
    list(filters, preventLoader = false, fields = this.listFields) {
        const query = this.prepareOptions({
            query: {
                __variables: this.listVariables,
                [this.listQueryName]: {
                    __args: this.listArgs,
                    list: fields,
                    count: true
                }
            }
        });
        return this.query({ query, variables: { filters } }, this.listQueryName, preventLoader);
    }
    /**
     * Pobranie pojedynczej encji
     *
     * @param {number} id
     * @param {boolean} [preventLoader=false]
     * @returns {Promise<EntityType>}
     * @memberof EntityResource
     */
    get(id, preventLoader = false, fields = this.getFields) {
        const query = this.prepareOptions({
            query: {
                __variables: this.getVariables,
                [this.entityQueryName]: {
                    __args: this.getArgs,
                    ...fields
                }
            }
        });
        return this.query({ query, variables: { id } }, this.entityQueryName, preventLoader);
    }
    /**
     * Dodanie encji
     *
     * @param {any} model - często jest to model + dodatkowe dane, typu identyfikator powiązanej encji, więc jest typu any
     * @returns {Promise<number>}
     * @memberof EntityResource
     */
    add(model) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: this.addVariables,
                [this.addMutationName]: { __args: this.addArgs }
            }
        });
        return this.mutation({ mutation, variables: model }, this.addMutationName);
    }
    /**
     * Aktualizacja encji
     *
     * @param {number} id
     * @param {EntityType} model
     * @returns {Promise<number>}
     * @memberof EntityResource
     */
    update(id, model) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: this.updateVariables,
                [this.updateMutationName]: { __args: this.updateArgs }
            }
        });
        return this.mutation({ mutation, variables: { ...model, id } }, this.updateMutationName);
    }
    /**
     * Usunięcie encji
     *
     * @param {number} id
     * @returns {Promise<number>}
     * @memberof EntityResource
     */
    delete(id) {
        const mutation = this.prepareOptions({
            mutation: {
                __variables: this.deleteVariables,
                [this.deleteMutationName]: { __args: this.deleteArgs }
            }
        });
        return this.mutation({ mutation, variables: { id } }, this.deleteMutationName);
    }
}
//# sourceMappingURL=entity.resource.js.map